import { module } from 'modujs';
import { Navigation, Swiper } from 'swiper';
import { leadingZero } from '../utils/maths'

export default class SliderFancy extends module {

    static get settings() {
        return {
        }
    }

    constructor(m) {
        super(m);

        // DOM
        this.$el = this.el
        this.$slider = this.$('slider')[0]
        this.$activeIndex = this.$('activeIndex')[0]

        // Options
        this.options = {
            allowTouchMove: false,
            loop: true,
            modules: [Navigation],
            navigation: {
                prevEl: this.$('prev')[0],
                nextEl: this.$('next')[0],
            },
            slidesPerView: 1,
            speed: 0.01,
            on: {
                activeIndexChange: e => this.$activeIndex.innerHTML = leadingZero(e.realIndex + 1, 2)
            }
        }
    }

    init() {
        this.swiper = new Swiper(this.$slider, this.options)
    }

    destroy() {
        super.destroy()

        this.swiper?.destroy()
    }
}
